import { render, staticRenderFns } from "./SettingsWorkstationTypes.vue?vue&type=template&id=2894269c"
import script from "./SettingsWorkstationTypes.vue?vue&type=script&lang=js"
export * from "./SettingsWorkstationTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports